import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { StandardProps } from '../../types/common';

import styles from './Menu.module.scss';

export const Menu = forwardRef<HTMLElement, StandardProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <nav ref={ref} className={clsx(styles['hds-menu'], className)} {...props}>
        <ul className={styles['hds-menu__items']}>
          {React.Children.map(children, (child) =>
            React.cloneElement(child as React.ReactElement, {
              isFirstChild: true,
            })
          )}
        </ul>
      </nav>
    );
  }
);
